import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  const axios = nuxtApp.$axios;
  const store = nuxtApp.$vuex;

  if (axios && store) {
    store.$axios = axios;
  }
});
